import { render, staticRenderFns } from "./TheGameStatus.vue?vue&type=template&id=5e4de816&"
import script from "./TheGameStatus.vue?vue&type=script&lang=js&"
export * from "./TheGameStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports